// since the backend is set for http secure only, I am using this in cookies
// without http secure only, because my pure js needs access to the code for the 
// children components
// export const setCookie = (name, value, minutes = 1) => { // used for testing
//   const date = new Date();
//   date.setTime(date.getTime() + minutes * 60 * 1000);
//   const expires = `expires=${date.toUTCString()}`;
//   document.cookie = `${name}=${value}; ${expires}; path=/; secure`;
// };
export const MEMBER_ID_COOKIE_NAME =
  process.env.REACT_APP_COOKIE_NAME || "skitsUserId";

export const setCookie = (name, value, days = 1) => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${name}=${value}; ${expires}; path=/; secure`;
};
// if i want to set it for longer the code example is below
// this will set the uuid which is seperate from the cookie token name
// export const setCookie = (name, value, days = 7) => {
//   const date = new Date();
//   date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
//   const expires = `expires=${date.toUTCString()}`;
//   document.cookie = `${name}=${value}; ${expires}; path=/; secure`;
// };

// Helper to get a cookie value
export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
};

// Helper to clear a cookie
export const clearCookie = (name) => {
  document.cookie = `${name}=; Max-Age=0; path=/;`;
};

export function clearAllCookies() {
  document.cookie.split(";").forEach((c) => {
    document.cookie = c
      .replace(/^ +/, "")
      .replace(/=.*/, `=;expires=${new Date(0).toUTCString()};path=/`);
  });
}


/**
 * Clears all cookies that start with the given currentContextType prefix.
 * For example, if currentContextType is "create", then cookies named
 * "create_billingCity", "create_creditCardNumber", etc. will be removed.
 */
export function clearCurrentContextTypeCookies(currentContextType) {
  // Retrieve all cookies
  const allCookies = document.cookie.split(";");
  // For each cookie, parse out the name
  allCookies.forEach((cookieStr) => {
    const [rawName] = cookieStr.split("=");
    const cookieName = rawName.trim();

    // If the cookie name starts with the given context prefix (e.g. "create_")
    if (cookieName.startsWith(`${currentContextType}_`)) {
      // Overwrite the cookie with an expired date
      document.cookie = `${cookieName}=; Max-Age=0; path=/;`;
    }
  });
}
